var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CardBase",
        [
          _c("MacroSubHeader", {
            attrs: { title: "Distribuidores", icon: "fas fa-users fa-1x" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-column mt-3",
              staticStyle: { gap: "20px" }
            },
            [
              _c("DistribuidorFilter", { on: { filtered: _vm.handleFilters } }),
              _vm._v(" "),
              _c("DistribuidorList", { ref: "distribuidorList" })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73baa0e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73baa0e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-73baa0e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Index.vue
// module chunks = 2